document.addEventListener("DOMContentLoaded", function () {

  const form = document.getElementById("supportForm");
  if (!form) return;

  const message = document.getElementById("message");

  const supabase = window.supabase.createClient(
    "https://ewfnslqyrsrjnfpincwn.supabase.co",
    "sb_publishable_LCfXItuUjM-6Qvlu6XNtPQ_bFv5kQQx"
  );

  form.addEventListener("submit", async function (e) {

    e.preventDefault();

    message.innerHTML = "⏳ Please wait... Uploading...";

    let attachmentUrl = "";

    // File Input
    const fileInput = document.getElementById("attachments");

    if (fileInput && fileInput.files.length > 0) {

      const files=fileInput.files;

for(const file of files){

   // upload

}

      console.log("Selected File:", file);

      // Max 100MB
      if (file.size > 100 * 1024 * 1024) {
        message.innerHTML = "❌ File size must be less than 100MB";
        return;
      }

      // Safe filename
      const fileName =
        Date.now() +
        "-" +
        file.name.replace(/\s+/g, "_");

      // Upload
      const { data: uploadData, error: uploadError } =
        await supabase.storage
          .from("support-files")
          .upload(fileName, file, {
            upsert: false,
            contentType: file.type
          });

      console.log(uploadData);
      console.log(uploadError);

      if (uploadError) {
        console.error(uploadError);
        message.innerHTML =
          "❌ Upload Failed : " + uploadError.message;
        return;
      }

      // Public URL
      const { data: publicUrlData } =
        supabase.storage
          .from("support-files")
          .getPublicUrl(fileName);

      attachmentUrl = publicUrlData.publicUrl;

      console.log("Attachment URL:", attachmentUrl);

    }

    // Ticket Data
    const ticketData = {

      ticket_no: "HP-" + Date.now(),

      order_no: document.getElementById("order_no").value,

      customer_name: document.getElementById("customer_name").value,

      email: document.getElementById("email").value,

      mobile: document.getElementById("mobile").value,

      product_name: document.getElementById("product_name").value,

      issue_type: document.getElementById("issue_type").value,

      issue: document.getElementById("issue").value,

      attachment_url: attachmentUrl,

      status: "Open"

    };

    console.log(ticketData);

    const { error } = await supabase
      .from("tickets")
      .insert([ticketData]);

    if (error) {
      console.error(error);
      message.innerHTML = "❌ " + error.message;
      return;
    }

    message.innerHTML = "✅ Ticket Submitted Successfully";

    form.reset();

  });

});